/* Tabela de tamanhos na mesma linha do rotulo "Rozmiar".
   O grupo de tamanhos e gerido pela app de swatches e pode ser recriado a
   qualquer momento, por isso a linha e o botao ficam FORA desse grupo:
   criamos a nossa propria linha imediatamente antes dele e escondemos o
   rotulo original. Assim nada se perde quando a app volta a desenhar. */
(function () {
  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function sizeGroup(wrap) {
    var groups = wrap.querySelectorAll('.swatch-single, .selector-wrapper');
    var found = null;
    for (var i = 0; i < groups.length; i++) {
      if (!isVisible(groups[i])) continue;
      var txt = (groups[i].textContent || '').trim();
      if (/^Rozmiar/i.test(txt) || /^Size/i.test(txt)) found = groups[i];
    }
    return found;
  }

  function place() {
    var wraps = document.querySelectorAll('.form__width');
    for (var w = 0; w < wraps.length; w++) {
      var wrap = wraps[w];

      var chart = wrap.querySelector('.pify_size_chart_wrapper');
      if (!chart) continue;

      var group = sizeGroup(wrap);
      if (!group || !group.parentNode) continue;

      var row = wrap.querySelector('.jw-size-row');

      if (!row) {
        var nameEl = group.querySelector('.swatch-option-name, legend');
        var name = nameEl ? (nameEl.textContent || '').trim() : 'Rozmiar';
        name = name.split('\n')[0].trim() || 'Rozmiar';

        row = document.createElement('div');
        row.className = 'jw-size-row';

        var span = document.createElement('span');
        span.className = 'jw-size-row__label';
        span.textContent = name;
        row.appendChild(span);

        group.parentNode.insertBefore(row, group);
      } else if (row.nextElementSibling !== group) {
        group.parentNode.insertBefore(row, group);
      }

      if (!row.contains(chart)) row.appendChild(chart);

      group.classList.add('jw-size-hide-label');
    }
  }

  function boot() {
    place();
    var tries = 0;
    var timer = setInterval(function () {
      place();
      if (++tries > 20) clearInterval(timer);
    }, 500);

    if (document.body) {
      new MutationObserver(function () {
        place();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
